import { getData, removeData, storeData } from "../../helper/arrayFormatter";
import { API_LOGOUT } from "../../api/api";
import { axiosPost } from "../../services/http.services";
import { logoutUser, setUser } from "../slices/authSlice";

const parseJwtPayload = (token) => {
	if (!token || typeof token !== "string" || token.split(".").length < 2) {
		return null;
	}

	try {
		const base64 = token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/");
		const padded = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), "=");
		return JSON.parse(atob(padded));
	} catch (error) {
		return null;
	}
};

export const loginUser = async (userData, dispatch) => {
	try {
		const jwtPayload = parseJwtPayload(userData?.token);
		const normalizedUser = {
			...userData,
			role: jwtPayload?.role || userData?.role,
		};

		dispatch(setUser(normalizedUser));
		storeData("user", JSON.stringify(normalizedUser));
		storeData("token", normalizedUser?.token);
		return true;
	} catch (error) {
		console.log(error);
		return false;
	}
};

export const logoutUserAction = async (dispatch) => {
	const userRaw = getData("user");
	let token = getData("token");
	if (!token && userRaw) {
		try {
			token = JSON.parse(userRaw)?.token;
		} catch (error) {
			console.error("Error parsing user token:", error);
		}
	}

	if (token) {
		try {
			await axiosPost(
				API_LOGOUT,
				{},
				{
					headers: { Authorization: `Bearer ${token}` },
					timeout: 2000,
				}
			);
		} catch (error) {
			console.error("Server logout request error or timed out:", error);
		}
	}

	removeData("user");
	removeData("token");
	dispatch(logoutUser());
};
